import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";
import SolanaTradingView from "../views/SolanaTradingView.vue";
import BSCTradingView from "../views/BSCTradingView.vue";
import EthereumTradingView from "../views/EthereumTradingView.vue";
import LoginView from "@/views/LoginView.vue";
import HomeView from "@/views/HomeView.vue";
import DashboardView from "@/views/DashboardView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: "/solana",
    name: "solana",
    component: SolanaTradingView,
    meta: { requiresAuth: true, network: "solana" },
  },
  {
    path: "/ethereum",
    name: "ethereum",
    component: EthereumTradingView,
    meta: { requiresAuth: true, network: "ethereum" },
  },
  {
    path: "/bsc",
    name: "bsc",
    component: BSCTradingView,
    meta: { requiresAuth: true, network: "bsc" },
  },
  {
    path: "/base",
    name: "base",
    component: EthereumTradingView,
    meta: { requiresAuth: true, network: "base" },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  await store.commit("app/setIsLoading", true);
  if (!store.getters["auth/isAuthenticated"]) {
    if (to.meta.requiresAuth) {
      if (!(await store.dispatch("auth/checkAuth"))) {
        return next({ path: "/login" });
      }
    }
  } else {
    if (to.name === "login") {
      return next({ path: "/" });
    }
  }
  if (to.name === "dashboard") {
    if (store.state.auth.user.username !== "meng0x") {
      return next({ path: "/" });
    }
  }
  if (to.meta.network) {
    await store.commit(
      "network/setChain",
      store.getters["network/chainList"][to.meta.network]
    );
  }
  next();
});

router.afterEach((to) => {
  setTimeout(
    () => {
      store.commit("app/setIsLoading", false);
    },
    to.meta.network ? 2200 : 500
  );
});

export default router;
